import { render, staticRenderFns } from "./Coronavirus.vue?vue&type=template&id=a7b0ec1c&"
import script from "./Coronavirus.vue?vue&type=script&lang=js&"
export * from "./Coronavirus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports